<template>
  <div
    class="empty-list-content d-flex flex-column flex-center index-1"
    v-if="show_empty"
  >
    <!-- EMPTY IMAGE -->
    <div class="show-large-img" :class="display_color" v-if="show_large">
      <img v-lazy="localImg(display_img)" alt />
    </div>

    <div
      class="avatar avatar_xxl custom-img"
      :class="display_color"
      v-else-if="show_no_bg"
    >
      <img v-lazy="localImg(display_img)" alt class="avatar-img" />
    </div>

    <div class="avatar avatar_xxl small-img" :class="display_color" v-else>
      <img v-lazy="localImg(display_img)" alt class="avatar-img" />
    </div>

    <!-- HEADER TEXT -->
    <div class="header-text font-weight-bold brand_navy" v-if="header_title">
      {{ header_title }}
    </div>
    <!-- HEADER TEXT -->

    <!-- INFO TEXT -->
    <div
      class="info-text text-center"
      :class="display_light_text ? 'brand_inverse_light' : 'color_tetxt'"
    >
      {{ display_text }}
    </div>

    <!-- CTA BUTTON -->
    <div class="btn-contain" v-if="show_button">
      <router-link
        :to="{ name: button_route_name }"
        class="btn btn-md btn-accent text-uppercase"
        v-if="button_type === 'route'"
        >{{ button_text }}</router-link
      >

      <router-link
        to
        class="btn btn-md btn-accent text-uppercase"
        @click.native="$emit(button_function)"
        v-if="button_type === 'emit'"
        >{{ button_text }}</router-link
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "EmptyContent",

  props: {
    display_img: String,
    display_color: String,
    display_text: String,
    header_title: String,
    display_light_text: {
      type: Boolean,
      default: false,
    },
    button_type: {
      type: String,
      default: "emit",
    },
    button_text: String,
    button_function: String,
    button_route_name: String,
    show_button: {
      type: Boolean,
      default: true,
    },
    show_empty: {
      type: Boolean,
      default: false,
    },
    show_large: {
      type: Boolean,
      default: false,
    },
    show_no_bg: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.empty-list-content {
  @include transform_center;

  .avatar {
    margin-bottom: 20px;
    position: relative;
    overflow: hidden;
  }

  .show-large-img {
    width: 230px;
    height: 140px;
    margin-top: -30px;
    margin-bottom: 15px;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .small-img {
    width: 80px !important;
    height: 80px !important;
    img {
      width: 100%;
      height: 100%;
    }

    .custom-img {
      @include custom-min-edge(130, 125);
    }
  }

  .header-text {
    font-size: 16px;
    line-height: 165%;
    margin: 10px auto 20px;

    @include breakpoint_max(xs) {
      font-size: 14px;
    }
  }

  .info-text {
    width: 90%;
    margin-bottom: 14px;
    font-size: 14px;
    line-height: 145%;

    @include breakpoint_max(md) {
      width: 100%;
      font-size: 13px;
      line-height: 20px;
    }

    @include breakpoint_max(xs) {
      width: 90%;
      font-size: 12px;
    }
  }

  .btn {
    @include breakpoint_max(md) {
      font-size: 11px;
      padding: 5px 14px;
    }

    @include breakpoint_max(xs) {
      font-size: 9px;
      padding: 4px 12px;
    }
  }

  .btn-md {
    @include breakpoint_max(md) {
      font-size: 11px;
      padding: 5px 14px;
    }

    @include breakpoint_max(xs) {
      font-size: 9px;
      padding: 4px 12px;
    }
  }
}
</style>
